import { render, staticRenderFns } from "./AdminTasks.vue?vue&type=template&id=4a7c3fa2&scoped=true"
import script from "./AdminTasks.vue?vue&type=script&lang=js"
export * from "./AdminTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7c3fa2",
  null
  
)

export default component.exports